import { render, staticRenderFns } from "./AdminPaymentHistory.vue?vue&type=template&id=5670d5c2&scoped=true&"
import script from "./AdminPaymentHistory.vue?vue&type=script&lang=js&"
export * from "./AdminPaymentHistory.vue?vue&type=script&lang=js&"
import style0 from "./AdminPaymentHistory.vue?vue&type=style&index=0&id=5670d5c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5670d5c2",
  null
  
)

export default component.exports